<template>
  <div class="developer" style="background: #fff">
    <div class="banner">
      <div class="banner-title1">探索 &nbsp; 创新 &nbsp; 求变</div>
      <p class="banner-title2">快速部署实时云渲染平台，一次发布，多端运行</p>
      <p class="banner-title3">立即<span> &nbsp;[ 开启CloudXR之旅 ]</span> </p>
      <router-link :to="{path:'/login'}" style="color: #fff">
        <p class="banner-title4 font-16 pointer">加入开发者</p></router-link>
    </div>
    <div class="small-nav-box">
     <!-- <div class="search-box">

        <input placeholder="输入搜索词">
        <p class="search-btn font-16">搜索</p>

      </div>-->
      <div class="small-nav w1200 flex-space-between">
        <div>
          <p>手册</p>
          <p><span>LarkSR</span><span>LarkVR</span><span>LarkAR</span></p>
        </div>
        <div>
          <p>API</p>
          <p><span>3.0接口文档</span></p>
        </div>
        <div>
          <p>下载</p>
          <p><span>产品系列</span><span>辅助工具</span></p>
        </div>
        <div>
          <p>FAQ</p>
        </div>
      </div>
    </div>
    <div class="wrap w1200">
      <div class="value-title w1200">
        <p>产品下载</p>
        <span></span>
      </div>
      <div class="wrap-content">
        <div class="wrap-small-title-box flex-space-between" style="position: relative;">
          <div class="left-box">
            <p class="left-title">
              服务端
            </p>
            <span style="position: absolute;bottom: 0;left:0;"></span>

          </div>
          <div class="right primary-color">
            <span class="wrap-right-btn">使用手册</span>
            <span class="wrap-right-btn">接口文档</span>
            <span class="wrap-right-btn">培训视频</span>
          </div>
        </div>
        <div class="wrap-content-content flex-space-between">
          <div class="left-wrap-content-content flex-space-between">
            <div class="img-box">
              <div class="img-small-box">
                <img style="width: 25px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1125@2x.png" alt="">
                <span class="primary-color">LarkXR</span>

              </div>
              <img style="width: 50px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1126@2x.png" alt="">

            </div>
            <div class="content">
              <p class="top-title">LarkXR 单机版</p>
              <p class="center-text">快速部署，即刻实现CloudXR应用 </p>
              <p class="center-text">版本信息： 3.1.6.1 </p>
              <p class="center-text">适配系统： 支持Windows Server2016+/Windows 10</p>
              <p class="center-text">更新时间： 2021-5-12</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>
          <div class="left-wrap-content-content flex-space-between">
            <div class="img-box">
              <div class="img-small-box">
                <img style="width: 25px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1125@2x.png" alt="">
                <span class="primary-color">LarkXR</span>

              </div>
              <img style="width: 109px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1127@2x.png" alt="">

            </div>
            <div class="content">
              <p class="top-title">LarkXR 简易集群版</p>
              <p class="center-text">快速部署，即刻实现CloudXR应用
              </p>
              <p class="center-text"> 版本信息： 3.1.6.1</p>
              <p class="center-text">适配系统： 支持Windows Server2016+/Windows 10</p>
              <p class="center-text"> 更新时间： 2021-05-12</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-content">
        <div class="wrap-small-title-box flex-space-between" style="position: relative;">
          <div class="left-box">
            <p class="left-title">
              客户端
            </p>
            <span style="position: absolute;bottom: 0;left:0;"></span>

          </div>
          <div class="right primary-color">
            <span class="wrap-right-btn">使用手册</span>
            <span class="wrap-right-btn">接口文档</span>
            <span class="wrap-right-btn">培训视频</span>
          </div>
        </div>
        <div class="wrap-content-content1 wrap-content-content flex-space-between">
          <div class="left-wrap-content-content1 left-wrap-content-content  flex-space-between">
            <div class="img-box">
              <div class="img-small-box">
                <img style="width: 82px;" src="https://home-oss.pingxingyun.com/homePage/developer/组 78@2x(2).png" alt="">
              </div>


            </div>
            <div class="content">
              <p class="top-title">SR安卓应用SDK</p>
              <p class="center-text">功能说明： LarkSR3.0安卓SDK</p>
              <p class="center-text">  版本信息： 3.1.3.3</p>
              <p class="center-text"> 适配系统： Android 5.0 以上</p>
              <p class="center-text">更新时间： 2021-01-08</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>
          <div class="left-wrap-content-content1 left-wrap-content-content  flex-space-between">
            <div class="img-box">
              <div class="img-small-box" style="margin-top: 82px;">
                <img style="width: 96px;" src="https://home-oss.pingxingyun.com/homePage/developer/组 78@2x(3).png" alt="">
              </div>


            </div>
            <div class="content">
              <p class="top-title">一体机VR眼镜SDK</p>
              <p class="center-text">功能说明： LarkSR3.0安卓SDK</p>
              <p class="center-text">     版本信息： 3.1.3.3</p>
              <p class="center-text">  适配系统： Android 5.0 以上</p>
              <p class="center-text"> 更新时间： 2021-05-12</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>
          <div class="left-wrap-content-content1 left-wrap-content-content  flex-space-between">
            <div class="img-box">
              <div class="img-small-box" style="margin-top: 104px;">
                <img style="width: 88px;" src="https://home-oss.pingxingyun.com/homePage/developer/组 78@2x(6).png" alt="">
              </div>


            </div>
            <div class="content">
              <p class="top-title">Quest APP</p>
              <p class="center-text">功能说明： LarkSR电视盒子App


              </p>
              <p class="center-text">   版本信息： 3.1.3.3</p>
              <p class="center-text">  适配系统： 华为机顶盒</p>
              <p class="center-text">   更新时间： 2021-01-08</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>
          <div class="left-wrap-content-content1 left-wrap-content-content  flex-space-between">
            <div class="img-box">
              <div class="img-small-box" style="margin-top: 73px;">
                <img style="width: 75px;" src="https://home-oss.pingxingyun.com/homePage/developer/组 78@2x(7).png" alt="">
              </div>


            </div>
            <div class="content">
              <p class="top-title">HTC VIVE APP</p>
              <p class="center-text">功能说明： LarkSR安卓App</p>
              <p class="center-text">  版本信息： 3.1.3.3</p>
              <p class="center-text">   适配系统： 安卓手机</p>
              <p class="center-text"> 更新时间： 2021-01-08</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>
          <div class="left-wrap-content-content1 left-wrap-content-content  flex-space-between">
            <div class="img-box">
              <div class="img-small-box" style="margin-top: 84px;">
                <img style="width: 83px;" src="https://home-oss.pingxingyun.com/homePage/developer/组 78@2x(8).png" alt="">
              </div>


            </div>
            <div class="content">
              <p class="top-title">Pico Neo2 APP</p>
              <p class="center-text">功能说明： LarkSR电视盒子App

              </p>
              <p class="center-text">    版本信息： 3.1.3.3</p>
              <p class="center-text">  适配系统： 华为机顶盒</p>
              <p class="center-text">更新时间： 2021-01-08</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>
          <div class="left-wrap-content-content1 left-wrap-content-content  flex-space-between">
            <div class="img-box">
              <div class="img-small-box">
                <img style="width: 67px;" src="https://home-oss.pingxingyun.com/homePage/developer/组 78@2x(4).png" alt="">
              </div>


            </div>
            <div class="content">
              <p class="top-title">安卓手机APP</p>
              <p class="center-text">功能说明： LarkSR安卓App
              </p>
              <p class="center-text">  版本信息： 3.1.3.3</p>
              <p class="center-text">  适配系统： 安卓手机</p>
              <p class="center-text">更新时间： 2021-01-08</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>
          <div class="left-wrap-content-content1 left-wrap-content-content  flex-space-between">
            <div class="img-box">
              <div class="img-small-box" style="margin-top: 69px;">
                <img style="width: 88px;" src="https://home-oss.pingxingyun.com/homePage/developer/组 78@2x(5).png" alt="">
              </div>


            </div>
            <div class="content">
              <p class="top-title">电视盒子APP</p>
              <p class="center-text">功能说明： LarkSR电视盒子App

              </p>
              <p class="center-text">  版本信息： 3.1.3.3</p>
              <p class="center-text">    适配系统： 华为机顶盒</p>
              <p class="center-text">更新时间： 2021-01-08</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-content">
        <div class="wrap-small-title-box flex-space-between" style="position: relative;">
          <div class="left-box">
            <p class="left-title">
              功能组件
            </p>
            <span style="position: absolute;bottom: 0;left:0;"></span>

          </div>
          <div class="right primary-color">

          </div>
        </div>
        <div class="wrap-content-content1 wrap-content-content flex-space-between">
          <div class="left-wrap-content-content1 left-wrap-content-content  flex-space-between">
            <div class="img-box">
              <div class="img-small-box">
                <img style="width: 77px;" src="https://home-oss.pingxingyun.com/homePage/developer/组 78@2x(9).png" alt="">
              </div>


            </div>
            <div class="content">
              <p class="top-title">AI语音 APK</p>
              <p class="center-text">功能说明： LarkSR电视盒子App
              </p>
              <p class="center-text">  版本信息： 3.1.3.3</p>
              <p class="center-text">  适配系统： 华为机顶盒</p>
              <p class="center-text">更新时间： 2021-01-08</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>
          <div class="left-wrap-content-content1 left-wrap-content-content  flex-space-between">
            <div class="img-box">
              <div class="img-small-box" style="margin-top: 93px">
                <img style="width: 99px;" src="https://home-oss.pingxingyun.com/homePage/developer/组 78@2x(10).png" alt="">
              </div>


            </div>
            <div class="content">
              <p class="top-title">数据通道_与应用通信</p>
              <p class="center-text">功能说明： LarkSR电视盒子App
              </p>
              <p class="center-text">     版本信息： 3.1.3.3</p>
              <p class="center-text">  适配系统： Android 5.0 以上</p>
              <p class="center-text"> 更新时间： 2021-05-12</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>
          <div class="left-wrap-content-content1 left-wrap-content-content  flex-space-between">
            <div class="img-box">
              <div class="img-small-box" style="margin-top: 93px">
                <img style="width: 103px;" src="https://home-oss.pingxingyun.com/homePage/developer/组 78@2x(11).png" alt="">
              </div>


            </div>
            <div class="content">
              <p class="top-title">数据通道_与客户端通信</p>
              <p class="center-text">功能说明： LarkSR电视盒子App



              </p>
              <p class="center-text">   版本信息： 3.1.3.3</p>
              <p class="center-text">  适配系统： 华为机顶盒</p>
              <p class="center-text">   更新时间： 2021-01-08</p>
              <P class="btn-box primary-color">
                <span class="span-inline">更新日志</span>
                <span class="span-inline">下载</span>
              </P>
            </div>
          </div>

        </div>
      </div>

    </div>
    <div class=" tools ">
      <div class="wrap tool w1200">
        <div class="value-title w1200">
          <p>辅助工具</p>
          <span></span>
        </div>
        <div class="tool-item-box ">


          <div class="tool-item">
            <img style="width: 51px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1138@2x.png" alt="">
            <p>VNC</p>
            <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/homePage/tightvnc-2.8.11-gpl-setup-64bit.msi'">下载</p>
          </div>
          <div class="tool-item">
            <img style="width: 51px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1139@2x.png" alt="">
            <p>Chrome 浏览器</p>
            <div class="down-wrap" style="display: flex;">
              <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/exe/ChromeStandaloneSetup.exe'">Windows</p>
              <p class="down" onclick="javascrtpt:window.location.href='https://pxy-appli.oss.cn-north-1.myhwclouds.com/05acf445-8a9c-48da-a45b-ca3c299ac95c/googlechrome_152812933.dmg'">Mac</p>
            </div>
          </div>
          <div class="tool-item">
            <img style="width: 51px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1140@2x.png" alt="">
            <p>MySQL</p>
            <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/exe/mysql-installer-community-5.7.26.0.msi'">下载</p>
          </div>
          <div class="tool-item">
            <img style="width: 51px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1141@2x.png" alt="">
            <p>HeidiSQL</p>
            <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/homePage_2_0/HeidiSQL_11.0_64_Portable.zip'">下载</p>
          </div>
          <div class="tool-item">
            <img style="width: 51px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1142@2x.png" alt="">
            <p>Notepad++</p>
            <div class="down-wrap" style="display: flex;">
              <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/exe/npp.7.5.9.Installer.exe'">Windows</p>
              <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/exe/npp.7.5.9.Installer.x64.exe'">Mac</p>
            </div>
          </div>
          <div class="tool-item">
            <img style="width: 51px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1143@2x.png" alt="">
            <p>VC运行库</p>
            <div class="down-wrap" style="display: flex;">
              <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/homePage/VisualCppRedist_AIO_x86_x64.exe'">下载</p>
            </div>
          </div>

          <div class="tool-item">
            <img style="width: 51px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1144@2x.png" alt="">
            <p>ADB TOOLS</p>
            <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/homePage/ADB%20TOOLS.zip'">下载</p>
          </div>
          <div class="tool-item">
            <img style="width: 51px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1145@2x.png" alt="">
            <p>无线网络信道 分析工具</p>
            <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/exe/%E6%97%A0%E7%BA%BF%E7%BD%91%E4%BF%A1%E9%81%93%E5%88%86%E6%9E%90%E5%B7%A5%E5%85%B7.zip'">下载</p>
          </div>
          <div class="tool-item">
            <img style="width: 51px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1146@2x.png" alt="">
            <p>DX11 runtime</p>
            <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/exe/dxwebsetup.exe'">下载</p>
          </div>
          <div class="tool-item">
            <img style="width: 51px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1147@2x.png" alt="">
            <p>SideQuest</p>
            <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/exe/SideQuest.zip'">下载</p>
          </div>
          <div class="tool-item">
            <img style="width: 51px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1148@2x.png" alt="">
            <p>虚拟手柄驱动</p>
            <p class="down" onclick="javascrtpt:window.location.href='https://home-oss.pingxingyun.com/exe/ViGEmBus_Setup_1.16.116.exe'">下载</p>
          </div>

        </div>
      </div>

    </div>
    <div style="padding-top: 82px;">
      <div class="value-title w1200">
        <p>视频讲解</p>
        <span></span>
      </div>
      <div class="w1200 loop" style="position: relative;">
        <el-carousel :interval="4000" type="card" height="200px" arrow="always">
          <el-carousel-item v-for="item in 6" :key="item">
            <div class="pointer" style="position:relative;">
              <img style="width: 380px;height: 213px" src="https://home-oss.pingxingyun.com/homePage/developer/loop-01.jpg" alt="">
              <img src="https://home-oss.pingxingyun.com/homePage/bofang.png" alt="" class="ab-center bofang" style="z-index: 9999999999999999;width: 46px">
              <video
                controls
                style="width:380px;z-index: 9999999;display: none;"
                class="play-video ab-center" src="https://home-oss.pingxingyun.com/homePage/video/LarkXR-Learning-Part1-2020.mp4"></video>
            </div>
          </el-carousel-item>
        </el-carousel>

      </div>
    </div>
    <div class="ProductFunction">
      <div class="fun-wrap">
        <div class="w1200 fun-box">
          <div class="content-title">
            <p>产品功能</p>
            <span></span>
          </div>
          <div>
            <div class="fun-hover">
              <p>高性能实时云渲染</p>
              <p>★ 基于图形容器技术，实现GPU算力池化，降低成本<br />
                ★ 基于智能公平调度算法，支持计算资源动态调度<br />
                ★ 优化网络传输控制算法，提升用户体验<br />
                ★ 支持NVIDIA CloudXR SDK集成</p>
            </div>
            <div class="fun-hover">
              <p>多终端访问/交互</p>
              <p>★ 浏览器直接访问，提供Android、iOS等客户端APP<br />
                ★ 支持VR/AR眼镜、手机/Pad、PC、全息等终端交互<br />
                ★ 提供客户端SDK，适配更多复杂多样的设备终端</p>
            </div>
            <div class="fun-hover">
              <p>面向多场景的功能组件</p>
              <p style="padding-left: 35px;">
                <span>★ 互动模式</span><span>★ 视频融合</span><br /><span>★ 协同模式</span><span>★ 数据通道</span><br /><span>★ 智能语音交互</span><span>★ 预启动模式</span>
              </p>
            </div>
          </div>
          <div class="fun-hover">
            <p>Cloud XR PaaS 平台功能</p>
            <div>
              <div>
                <p>★ 系统部署及算力管理</p>
                <p>- 容器化高效部署<br />
                  - 大规模商业化集群部署<br />
                  - MEC 边缘云部署<br />
                  - 节点动态配置</p>
              </div>
              <div>
                <p>★ XR应用管理</p>
                <p>- XR应用统一上传、统一管理、自动分发<br />
                  - 大文件高速可靠传输<br />
                  - 冷热数据分类管理，兼顾用户体验与存储成本<br />
                  - 兼容不同引擎，应用零代码改动，一键发布</p>
              </div>
              <div>
                <p>★ 系统监控</p>
                <p>- 算力资源使用率监控<br />
                  - 客户端及应用运行画面监控<br />
                  - XR应用使用数据统计</p>
              </div>
              <div>
                <p>★ 更多</p>
                <p>- 多租户管理及组策略管理功能<br />
                  - 内网穿透及公网转发功能<br />
                  - 丰富的API及SDK，供二次开发</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div> <!-- $(".ProductFunction").load("common/ProductFunction.html") -->
    <div class="demo w1200">
      <!-- <img style="width: 760px;" src="https://home-oss.pingxingyun.com/homePage/developer/图层 1150@2x.png" alt=""> -->
      <video autoplay loop="loop" style="width:860px;" src="https://home-oss.pingxingyun.com/homePage/dev-video-demo.mp4"></video>
      <p class="pointer" onclick="javascrtpt:window.open('../experience.html')">体验Demo</p>
    </div>
    <div class="slogan"></div> <!-- $(".slogan").load("common/slogan.html") -->

  </div>

</template>

<script>

    export default {
        name: "home"
    }
</script>

<style scoped>
  @import "../../../../public/css/devCommon.css";
@import "../../../../public/css/dev.css";

</style>
